import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useRouteParams } from '../hooks/useRouteParams';

interface SetSelectedPortfolioParams {
  portfolioId: string;
}

const setSelectedPortfolioRequest = ({ clientId }) => ({
  portfolioId,
}: SetSelectedPortfolioParams) => {
  return authFetch(
    urlWithParams('/Consumer/AutomatedAccountsUpdate/SetSelectedPortfolio', {
      clientId,
    }),
    { method: 'POST', ...httpBodyOptions({ portfolioId }, true) },
  );
};

export const useSetSelectedPortfolioMutation = () => {
  const { clientId } = useRouteParams();

  return useMutation(setSelectedPortfolioRequest({ clientId }));
};
